import React from "react";
import dayjs from "dayjs";
import TableSpinner from "../../Utility/TableSpinner";
import { AgGridReact } from "ag-grid-react";
import {
  AllCommunityModule,
  ModuleRegistry,
  InfiniteRowModelModule,
  ClientSideRowModelModule,
} from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import { Whisper, Popover } from "rsuite";
import { useState, useMemo, useEffect, useRef, useCallback } from "react";
import { FiSearch, FiFilter, FiDownload } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import CustomHeader from "../../Utility/CustomHeader";
import PulseLoader from "../../Utility/PulseLoader";
import AppointmentFilterPopover from "../Appointments/AppointmentFilter";
import ActionCellRenderer from "../../Utility/ActionCellRenderer";
ModuleRegistry.registerModules([InfiniteRowModelModule]);

function AllAppointmentList({
  getAppointments,
  isFetching,
  isLoading,
  isSuccess,
  gridRef,
  selectedFilters,
  hasData,
  setHasData
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const CustomLoadingOverlay = () => (
    <div className="flex flex-col items-center justify-center h-full">
      <PulseLoader />
    </div>
  );

  const pagenumRef = useRef(1); // instead of useState
  const filterRef = useRef(selectedFilters);

  useEffect(() => {
   
    filterRef.current = Object.entries(selectedFilters).map(
      ([key, valueSet]) => {
        return {
          filterName: key,
          filterOperator: valueSet.operator,
          filterValue: Array.from(valueSet.values).join(", "),
        };
      }
    );
    pagenumRef.current = 1;
    setHasData(true);
  }, [selectedFilters]);

  const onSortChanged = useCallback(() => {
    pagenumRef.current = 1;
  }, []);

  const onGridReady = useCallback((params) => {
    const dataSource = {
      rowCount: undefined,
      getRows: async (params) => {
                let result;
        if(params.sortModel.length === 1 ){
         result = await getAppointments(pagenumRef.current, filterRef.current, params.sortModel[0].colId, params.sortModel[0].sort);
        }
        else{
         result = await getAppointments(pagenumRef.current, filterRef.current);
        }
          const rowsThisPage = result;
   if (rowsThisPage.length === 0 && pagenumRef.current === 1) {
  setHasData(false);  
} else {
  setHasData(true);
}

        let lastRow = -1;
        if (!rowsThisPage || rowsThisPage.length < 100) {
          lastRow = params.startRow + (rowsThisPage?.length || 0); // indicates end of data
        }

        params.successCallback(rowsThisPage, lastRow);

        if (rowsThisPage?.length === 100) {
          pagenumRef.current += 1;
        }
      },
    };

    params.api.setGridOption("datasource", dataSource);
  }, []);

  const tableStyle = `

  .focus\:ring-\[\#00C335\]:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(21 44 64 / 68%);
}

  .btn-IdWmkZEQJd {
  border: none;
    background: #dcf2ff;
    color: #035ecf;
    width: 2.4rem;
    height: 2.4rem;
    display: flex
;
    align-items: center;
    justify-content: center;
    border-radius: .245rem;
    padding: .25rem .5rem;
  }


.ag-horizontal-right-spacer.ag-scroller-corner {
    display: none !important;
}

.ag-header-viewport {
  overflow-x: hidden !important;
  will-change: auto !important;
}

/* Soothing green strip for selected row */
.ag-theme-quartz .ag-row-selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

.ag-cell-value{
  border-left: unset !important;
  border-right: 1px solid #e5e5e5 !important;
}

.ag-column-first{
  border: unset !important;
}

.ag-theme-quartz .ag-row-selected::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

/* Override hover background for selected rows */
.ag-theme-quartz .ag-row-hover .ag-row-selected:hover {
  background-color: #f4fbf1 !important; /* same as selected */
}

.ag-checkbox-input-wrapper::before{
  display: none;
}

.ag-checkbox-input-wrapper::after{
  display: none;
}

  .ag-ltr .ag-sort-indicator-icon {
    padding-left: var(--ag-grid-size);
    display: none;
}

  .ag-header, .ag-advanced-filter-header {
    // background-color: #ff525a;
      background-color: #A2AD91;
    border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}

            .ag-full-width-container{
            height : 100% !important;
          }


         

  
        .ag-header-cell-text {
        font-size: 0.9rem;
      text-transform: uppercase;
      color: #1e374f;
      font-weight: 600;
      font-family: 'Nunito', sans-serif !important;

        }

              .ag-header-cell-resize::after{
                      background-color: #1991eb52;
                  }



              .ag-ltr .ag-cell{
border-right: solid 1px #e5e7eb !important;
                      text-align: center;
                      display: flex;
                      // justify-content: center;
                      align-items: center;
              }

              .ag-header{
                  // background-color: #edeff6;
                   border: none;
                  padding: 0.5rem 0;

                  min-height: 44px !important;
              }

              .ag-row {
               border: 1px solid #eeedf0;

              }

                  .ag-row-odd {
    background-color: #fff !important; /* Light gray */
  }

                    .ag-row-even {
    background-color: #f7f7f7 !important; /* Light gray */
  }






              .ag-root-wrapper{
                border: unset;
                background: transparent
              }

              .ag-theme-quartz .ag-header-cell-filter-button{
              display: none;}

.ag-header-cell-resize:after {
    background-color: #1991eb52;
    content: "";
    display: block;
    height: 30%;
    position: absolute;
    top: calc(50% - 30% * .5);2px;
    z-index: 1;
}

               .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
                  font-size: .9rem;
               }

        .ag-body-vertical-scroll{
            display : none;
          }

    .ag-header-cell-sortable .ag-header-cell-label{
           justify-content: start;
        }
        
        .ag-ltr .ag-cell {
            font-weight: 500 !important;
            letter-spacing: 0.5px;
            color: #2b2b2b !important;
        }


          .odd-row {
          background-color: #f8f8fc;
        }
        
        .span-saceuu7u7{
            font-size: 13px; 
            background-color: #FAAB3C; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkm{
            font-size: 10px; 
            color: #6941C6 ;
            border: solid .1px #6941C6; 
            background-color: #F9F5FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkmjbui{
            font-size: 10px; 
            color: #175CD3 ;
            border: solid .1px #B2DDFF; 
            background-color: #EFF8FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
                .ag-header-cell-label{
        display: flex;
        justify-content: center;
        }
         .ag-cell:focus,
  .ag-cell-focus,
  .ag-row-focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

        
        
  
  `;
  const navigate = useNavigate();

  const getStableColor = (key) => {
    const bgColors = [
      "bg-danger bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-secondary bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-info bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-info bg-opacity-10",
      "bg-success bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-secondary bg-opacity-50",
    ];

    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % bgColors.length;
    return bgColors[index];
  };

  const [colDefs, setColDef] = useState([
       {
      headerName: "Patient ID",
      field: "patientIDUniqueID",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">
              {params.value}
            </span>
          );
        }
      },
    },
    {
      headerName: "Patient Name",
      field: "patientName",
      width: 170,
      minWidth: 170,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
        if (params.value !== undefined) {
          const name = params.value || "U";
          const initial = name.charAt(0).toUpperCase();
          const bgColor = getStableColor(name);

          return (
            <div className="d-flex align-items-center gap-2">
              <div
                className={`d-flex justify-content-center align-items-center rounded-circle text-white fw-bold ${bgColor}`}
                style={{ width: "2rem", height: "2rem", fontSize: "0.875rem" }}
              >
                {initial}
              </div>
              <span className="fw-bold text-secondary small">{name}</span>
            </div>
          );
        } else {
          <TableSpinner />;
        }
      },
    },
    {
      headerName: "Gender",
      field: "gender",
      minWidth: 180,
       cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },


    {
      headerName: "Date & Time",
      field: "appointmentDate",
      minWidth: 170,
       cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: function (params) {
      

        if (params.value !== undefined) {
          const formattedDate = dayjs(params.value)
            .format("DD-MMM-YYYY")
            .replace(
              /-(\w{3})-/,
              (_, month) =>
                `-${month.charAt(0).toUpperCase()}${month
                  .slice(1)
                  .toLowerCase()}-`
            );
          return (
            <>
              <span className="text-secondary fw-medium small">
                {formattedDate}
              </span>
            </>
          );
        }
      },
    },
    {
      headerName: "Status",
      field: "status",
      minWidth: 150,
       cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          const status = params.value;

          const statusStyles = {
            Confirmed: "border-1 border-blue-500 text-blue-500 bg-transparent",
            "In Progress": "bg-amber-400 text-white",
            Completed: "bg-emerald-500 text-white",
            Cancelled: "bg-red-500 text-white",
            Today: "bg-[rgb(209,74,74)] text-white border-[rgb(209,74,74)]",
            Upcoming: "bg-[#63b1f1] text-white",
          };

          return (
            <span
              className={`inline-flex items-center justify-center rounded-full text-xs font-semibold h-7 w-[110px] px-3 ${
                statusStyles[status] || "bg-gray-400 text-white"
              }`}
              style={{ minWidth: "110px", textAlign: "center" }}
            >
              {status}
            </span>
          );
        }
      },
    },

    {
      headerName: "Type",
      field: "visitType",
      minWidth: 140,
       cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Time Slot",
      field: "timeSlot",
      minWidth: 100,
       cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-primary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Actions",
      field: "Actions",
      minWidth: 60,
      sortable: false,
       cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: ActionCellRenderer,
    },
  ]);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
    };
  }, []);

  let content = null;
   if (!hasData) {
  content = (
    <div className="flex flex-col justify-center items-center h-[30rem]">
      <img
        src="/Images/doctortable.png"
        alt="No Patients"
        className="w-[400px] mb-4"
      />
      <p className="text-muted text-sm">No Appointments Available</p>
    </div>
  );
} else
  {
    content = (
      <div
        id="grid-wrapper"
        className="ag-theme-quartz custom-ag-grid"
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          minHeight: "36rem",
        }}
      >
        <style>{tableStyle}</style>
        <AgGridReact
          ref={gridRef}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowHeight={40}
          headerHeight={30}
          rowBuffer={0}
          rowModelType={"infinite"}
          cacheBlockSize={100}
          cacheOverflowSize={5}
          maxConcurrentDatasourceRequests={1}
          maxBlocksInCache={10}
          animateRows={true}
          onGridReady={onGridReady}
          onSortChanged={onSortChanged}

        />
      </div>
    );
  }
  return <div style={{ width: "100%", height: "100%" }}>{content}</div>;
}

export default AllAppointmentList;
